export default "__VITE_ASSET__DjtRbnZ0__"